var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{attrs:{"pill":"","variant":_vm.salesLeadOrigin.variant}},[_c('feather-icon',{attrs:{"icon":_vm.salesLeadOrigin.icon,"size":"16"}}),_vm._v(" "+_vm._s(_vm.salesLeadOrigin.text)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }